export const SHOW_ERROR = "ERROR/SHOW";
export const CLEAR_ERROR = "ERROR/CLEAR";

/**
 * Simple action to store an error in redux state
 * errType: string (one of ERROR_TYPES)
 * message: optional string
 */
export const showError = (errType, message = "", ip = "", country = "") => ({
  type: SHOW_ERROR,
  payload: {errType: errType, message, ip, country}, 
});

export const clearError = () => ({ type: CLEAR_ERROR });

/**
 * Thunk that dispatches the error into the store and then navigates
 * to the centralized error page with query params.
 *
 * Usage: dispatch(showErrorAndRedirect(errType, message, ip, country));
 */
export const showErrorAndRedirect = (errType, message = "", ip = "", country = "") => (dispatch) => {
  dispatch(showError(errType, message, ip, country));

  try {
    const errParam = encodeURIComponent(errType || "auth_error");
    const msgParam = encodeURIComponent(message || "");
    const ipParam = encodeURIComponent(ip || "");
    const countryParam = encodeURIComponent(country || "");
    const errorUrl = `${window.location.origin}/error?err=${errParam}&msg=${msgParam}&ip=${ipParam}&country=${countryParam}`;
    // replace so back doesn't return to protected page
    window.location.replace(errorUrl);
  } catch (navErr) {
    // swallow navigation errors
  }
};